import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";

Vue.config.productionTip = false;

//axios.defaults.baseURL = "http://10.10.1.23:3006/api/";
//axios.defaults.baseURL = "http://10.10.1.113:3000/api/";
axios.defaults.baseURL = "https://sipavi.aevivienda.gob.bo/api/";

//axios.defaults.baseURL = "http:/localhost:3001/api/";

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
